import { normalize } from '../../lib/text';

/**
 * 検索語を <mark> で強調する。
 * NFKC正規化した文字列で位置を求め、元の文字列を同じ位置で切り出す。
 * 正規化で文字数が変わる場合があるため、長さが一致するときだけ強調する。
 */
export function Highlight({ text, terms }: { text: string; terms: string[] }) {
  if (terms.length === 0 || text === '') return <>{text}</>;

  const norm = normalize(text);
  if (norm.length !== text.length) return <>{text}</>;

  const ranges: [number, number][] = [];
  for (const t of terms) {
    if (!t) continue;
    let from = 0;
    for (;;) {
      const at = norm.indexOf(t, from);
      if (at < 0) break;
      ranges.push([at, at + t.length]);
      from = at + t.length;
    }
  }
  if (ranges.length === 0) return <>{text}</>;

  ranges.sort((a, b) => a[0] - b[0]);
  const merged: [number, number][] = [];
  for (const r of ranges) {
    const last = merged[merged.length - 1];
    if (last && r[0] <= last[1]) last[1] = Math.max(last[1], r[1]);
    else merged.push([...r] as [number, number]);
  }

  const out: React.ReactNode[] = [];
  let cursor = 0;
  merged.forEach(([s, e], i) => {
    if (s > cursor) out.push(text.slice(cursor, s));
    out.push(<mark key={i}>{text.slice(s, e)}</mark>);
    cursor = e;
  });
  if (cursor < text.length) out.push(text.slice(cursor));
  return <>{out}</>;
}
